const levels = ['h1', 'h2', 'h3'] as const;

export const levelToVariant = (level: number) => {
  return levels[level] || 'h3';
};
